import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

import { StateMap, UnitOfWork, UserManager } from '../../services/common';
import { EditManager, IEditHost, LocationFns } from '../../utils/common';

import { MATERIAL_ROUTES } from './material.routes';
import { RegulatoryStatusComponent } from './regulatory-status.component';
import { RegulatoryStatus } from '../../entities/EntityModels';

import {HttpClient, HttpHeaders, HTTP_INTERCEPTORS} from '@angular/common/http';
import {Observable} from 'rxjs';

@Component({
    selector: 'regulatory-statuses',
    templateUrl: './regulatory-statuses.html',
})
export class RegulatoryStatusesComponent implements IEditHost<RegulatoryStatus>, OnInit {
    @Input() materialId: number;
    @Input() statusType: string;

    @ViewChild(RegulatoryStatusComponent) _editingComponent: RegulatoryStatusComponent;

    _edm: EditManager<RegulatoryStatus>;

    _documentManagementUrl: string;
    _isLoading = false;
    _validationMessage: string;

    constructor(public _uow: UnitOfWork, public _userManager: UserManager, public _stateMap: StateMap, public _location: Location, public _httpClient: HttpClient) {

    }

    ngOnInit() {
        this._stateMap.currentRouteName = MATERIAL_ROUTES.Status.name;
        let tab: number;
        if (this.statusType == 'general') {
            tab = 0;
        } else if (this.statusType == 'ifra') {
            tab = 1;
        } else if (this.statusType == 'occupational') {
            tab = 2;
        } else {
            tab = 0;
        }
        LocationFns.setTab(this._location, tab);
        const displayName = (this.statusType == 'ifra') ? 'IFRA' : this.statusType;
        this._edm = new EditManager<RegulatoryStatus>(this, this._uow, this._stateMap, displayName);

        this._edm.pageState.isLoading = true;
        const p = {materialId: this.materialId, statusType: this.statusType};
        this._uow.regulatoryStatusRepository.whereWithParams(p).then(r => {
            this._edm.entities = r;
            this._edm.pageState.isLoaded = r;
        });

        this._uow.getDocumentManagementUrl().then(url => {
            this._stateMap.documentManagementBaseUrl = url;
            this._documentManagementUrl = this._stateMap.documentManagementBaseUrl  + '/RIFMDownloadableFile';
        });
    }

    canDeactivate() {
        return !this._edm.hasEdits();
    }

    selectWebRef(rs: RegulatoryStatus) {
        const data = rs.webReferenceExt();

        if (!this.isValidString(data)) {
            return false;
        }

        if ((data.indexOf('http') == 0)) {
            window.open(data);
            return false;
        }

        const fileParts = this.splitFileData(data);

        if (fileParts == null || fileParts.length < 2) {
            return;
        }
        const fileName  = fileParts.pop();
        const subFolder = fileParts.join('\\');

        return (this.exportContentFile(fileName, subFolder));

    }

    splitFileData(data: string) {
        if (!this.isValidString(data)) {
            return null;
        }
        let fileParts = data.split('/');
        if (fileParts != null && fileParts.length >= 2) {
            return fileParts;
        }

        // some regulatory status file paths have a different delimiter
        fileParts = data.split('\\');
        if (fileParts != null && fileParts.length >= 2) {
            return fileParts;
        }
        return null;
    }

    isValidString(teststring: string) {
        if (!teststring) { return false; }

        return (teststring.trim().length > 0);
    }

    onAdd() {
        if (!this._edm.validateCurrent()) {
            return;
        }
        const rs = this._uow.regulatoryStatusFactory.create();
        rs.materialId = this.materialId;
        this._edm.entities.push(rs);
        this._edm.onSelect(rs);
    }

    isPermittedRole() {
        return this._userManager.currentUser.isStaff || this._userManager.currentUser.isAgentReadOnly;
    }

    // ************************************************************************
    // document management web api url
    // ************************************************************************
    getDownloadFileURL(fileName: string, subFolder: string): Observable<any> {
        let url: string;
        url = this._documentManagementUrl + '/GetFileBySubFolderAndName?fileName=' + fileName + '&subFolder=' + subFolder ;

        return this._httpClient.get<any>(url, { responseType: 'blob' as 'json'});
    }

    public exportContentFile(fileName: string, subFolder: string) {
        this._isLoading = true;
        this._validationMessage = '';
        this.getDownloadFileURL(fileName, subFolder)
            .subscribe(
                (response: Blob) => {
                    const data = response;

                    const file = new Blob([data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);

                    const a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = fileName;
                    document.body.appendChild(a);
                    a.click();
                    
                    a.remove();

                    window.URL.revokeObjectURL(fileURL);                    

                    this._validationMessage = 'File download successful.';

                },
                (error) => {
                    console.error('Request failed with error: ' + error.message);
                    this._validationMessage = error.message;
                    this._isLoading = false;
                },
                () => {
                    this._isLoading = false;
                });
    }
}
